import { studioApiSdk } from '@/lib/fetcher'
import { StudioSecret } from '@/features/secrets'

export const getSecrets = async (projectId: number): Promise<StudioSecret[]> => {
  return studioApiSdk.getSecrets(projectId)
}

export const getSecret = async (projectId: number, secretId: number): Promise<StudioSecret> => {
  return studioApiSdk.getSecret(projectId, secretId)
}

export const createSecret = async (projectId: number, secret: StudioSecret): Promise<StudioSecret> => {
  return studioApiSdk.createSecret(projectId, secret)
}

export const updateSecret = async (
  projectId: number,
  id: number,
  secret: Partial<StudioSecret>
): Promise<StudioSecret> => {
  // @ts-expect-error name can be optional here
  return studioApiSdk.updateSecret(projectId, id, secret)
}
